import { useCallback } from "react";

import FormControlLabel from "components/FormControlLabel";
import Switch from "components/Switch";
import Text from "components/Text";
import Tooltip from "components/Tooltip";

interface IAssetManagementToggle {
  label: string;
  onToggleChange: (checked: boolean) => void;
  tooltip?: string;
  disabled?: boolean;
  checked?: boolean;
  dataTestid?: string;
  isSettingsToggle?: boolean;
}
const AssetManagementToggle: React.FC<IAssetManagementToggle> = ({
  label,
  onToggleChange,
  checked,
  dataTestid,
  tooltip,
  disabled = false,
  isSettingsToggle = false,
}) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onToggleChange(event.target.checked);
    },
    [onToggleChange]
  );

  return (
    <Tooltip title={tooltip}>
      <span>
        <FormControlLabel
          label={
            <Text
              noWrap
              variant="text2"
              sx={{ fontWeight: 500 }}
              data-testid="label"
              width={isSettingsToggle ? "200px" : "fit-content"}
            >
              {label}:
            </Text>
          }
          disabled={disabled}
          control={
            <Switch
              defaultChecked={checked === undefined}
              checked={checked}
              onChange={handleChange}
              data-testid="toggle"
            />
          }
          labelPlacement="start"
          data-testid={dataTestid}
          sx={{ margin: "inherit" }}
        />
      </span>
    </Tooltip>
  );
};

export default AssetManagementToggle;
